import { Button } from 'antd';
import React, { memo } from 'react';
import { modeSwitcherOptions } from '../CreateNewWorkScheduleByPeriod.constants';
import styles from '../CreateNewWorkScheduleByPeriod.module.scss';

export const ModeSwitcher = memo(function ModeSwitcher({
  value,
  options = modeSwitcherOptions,
  disabled = false,
  lockInactive = false,
  onChange,
}) {
  return (
    <div className={styles.modeSwitcher}>
      {options.map((option) => (
        <Button
          key={option.value}
          disabled={
            disabled ||
            option.disabled ||
            (lockInactive && value !== option.value)
          }
          type={value === option.value ? 'primary' : 'default'}
          onClick={() => {
            if (!option.disabled && value !== option.value) {
              onChange(option.value);
            }
          }}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
});
